import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { HandleDeviceIdTree } from '@blade/common/store/deviceTree';
import { queryDeviceRtspPreviewAddress } from '@blade-sxp/task-management/api/creat-task/index';
import { isEmpty } from 'lodash';
// import { EventBus } from '@blade/common';
import { plotMap } from './plotConfig';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
const Service = { queryDeviceRtspPreviewAddress };
let DeviceList = class DeviceList extends Vue {
    deviceIdList;
    taskType;
    uncheckedImg = require('@blade-sxp/task-management/assets/subtract.png');
    selectedDeviceIdList = [];
    deviceList = HandleDeviceIdTree.treeToDeviceIdList;
    selectDeviceId = '';
    selectDeviceIndex = 0;
    isDeleteBtn = false;
    completedNumber = 0;
    init(val) {
        const { type } = val.query;
        this.isDeleteBtn = type !== 'detail';
    }
    onChangeDeviceIdList(val) {
        if (!isEmpty(val) && !isEmpty(this.deviceList)) {
            this.selectDeviceId = '';
            this.selectedDeviceIdList = this.getSelectDeviceIdList(val);
        }
        else {
            this.selectedDeviceIdList = [];
        }
    }
    onChangeSelectDeviceId(val) {
        if (!isEmpty(val)) {
            this.$nextTick(() => {
                if (isEmpty(this.selectDeviceId)) {
                    const id = val[0]?.id;
                    this.getRtspUrl(id, 0);
                    this.selectDeviceId = id;
                }
                const data = val.filter((item) => item.isComplete === true);
                this.completedNumber = data.length;
                if (this.completedNumber === this.deviceListLenght) {
                    DeviceIdDataModule.updataComplete(true);
                }
                else {
                    DeviceIdDataModule.updataComplete(false);
                }
            });
        }
        else {
            this.selectDeviceId = '';
            this.selectDeviceIndex = 0;
            this.completedNumber = 0;
            DeviceIdDataModule.updataCurrentRtspUrl('');
        }
        this.$emit('selectedDevices', val);
    }
    onchangeMonitoringIndex(val) {
        const params = DeviceIdDataModule?.deviceIdRequestParams?.get(this.selectDeviceId);
        if (!isEmpty(params) && val && !isEmpty(this.selectedDeviceIdList)) {
            const statusMap = params.isComplete;
            this.selectedDeviceIdList.forEach((item) => {
                if (item.id === this.selectDeviceId) {
                    item.isComplete = statusMap;
                }
            });
        }
    }
    get isDeviceList() {
        return !isEmpty(this.selectedDeviceIdList);
    }
    get deviceListLenght() {
        return this.selectedDeviceIdList?.length;
    }
    get isShowTip() {
        const type = plotMap.get(this.taskType);
        return type?.timeline?.length > 0;
    }
    get monitoringIndex() {
        return DeviceIdDataModule.monitoringIndex;
    }
    getSelectDeviceIdList(val) {
        let data = [];
        if (val && this.deviceList) {
            this.deviceList.forEach((item) => {
                val.forEach((el) => {
                    if (String(item.id) === String(el) && item.nodeType === 'DEVICE') {
                        const params = DeviceIdDataModule?.deviceIdRequestParams?.get(String(el));
                        const statusMap = params?.isComplete;
                        data.push({ ...item, isComplete: statusMap });
                    }
                });
            });
        }
        return data;
    }
    getRtspUrl(id, index) {
        if (this.selectDeviceId !== id) {
            this.selectDeviceId = id;
            this.selectDeviceIndex = index;
            DeviceIdDataModule.updataDeviceId(id);
            Service.queryDeviceRtspPreviewAddress(id).then((res) => {
                const url = res.rtspPreviewAddress;
                DeviceIdDataModule.updataCurrentRtspUrl(url);
            });
        }
    }
    deleteDeviceId(id) {
        this.$emit('delete-id', id);
        DeviceIdDataModule.markMapData.clear();
        DeviceIdDataModule?.updataIsMapData(false);
    }
};
__decorate([
    Prop({ type: Array })
], DeviceList.prototype, "deviceIdList", void 0);
__decorate([
    Prop({ type: String, default: '' })
], DeviceList.prototype, "taskType", void 0);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], DeviceList.prototype, "init", null);
__decorate([
    Watch('deviceIdList', { deep: true, immediate: true })
], DeviceList.prototype, "onChangeDeviceIdList", null);
__decorate([
    Watch('selectedDeviceIdList', { deep: true, immediate: true })
], DeviceList.prototype, "onChangeSelectDeviceId", null);
__decorate([
    Watch('monitoringIndex', { immediate: true })
], DeviceList.prototype, "onchangeMonitoringIndex", null);
DeviceList = __decorate([
    Component({
        name: 'DeviceList',
        components: {},
        i18n: {
            messages: {
                en: {
                    addDevice: 'Added Device',
                    total: 'Total',
                    completed: 'Completed',
                    notCompleted: 'the device was not completed',
                },
                zh: {
                    addDevice: '添加设备',
                    total: '总数',
                    completed: '已完成',
                    notCompleted: '设备未完成',
                },
            },
        },
    })
], DeviceList);
export default DeviceList;
